import React, { useCallback } from 'react';
import { applyModel } from '../../../helpers';
import { useTempState, useUnitData } from '@starflow/app/store';
import { updateModelItem } from '../../../store/actions';
import { ModelCard } from '../Card';
import HeaderNav from './HderNav';
import { useCategories } from '../../../store/state';

const colsClassNames = {
  4: 'grid-cols-4',
  5: 'grid-cols-5',
};

export const ClassificationList = React.memo(
  ({ data, cols = 5, cardSize = {}, filters, withHotBadge, showTag, withAuthorInfo, handleApplyFilter }) => {
    const arr = Object.values(data);
    const { checkpoint: unitCheckpoint, loraModels: unitLoraModels = [] } = useUnitData();

    const tempPickingModel = useTempState('tempPickingModel');
    const tempCheckpoint = useTempState('tempCheckpoint');
    const tempLoras = useTempState('tempLoras', []);

    const checkpoint = tempPickingModel ? tempCheckpoint : unitCheckpoint;
    const loraModels = tempPickingModel ? tempLoras : unitLoraModels;

    const categories = useCategories((state) => state.lora);
    const currentCheckpointId = checkpoint?.versionId;
    const currentLoraIdsMap = Object.fromEntries(loraModels?.map((item) => [item?.versionId, true]));

    const getMore = (category) => {
      handleApplyFilter(category);
    };
    const arrs = useCallback(() => {
      if (filters.category === '0') {
        const orderList = categories.featuredCates;
        const res = [];
        orderList.forEach((order) => {
          arr.forEach((ar) => {
            if (order.includedTags === ar.featuredCate.includedTags) {
              res.push(ar);
            }
          });
        });
        return res;
      } else {
        const orderList = categories.catalogArr.find((cate) => cate.code === filters.category);
        const res = [];
        orderList.level2.forEach((order) => {
          arr.forEach((ar) => {
            if (order.includedTags === ar.featuredCate.includedTags) {
              res.push(ar);
            }
          });
        });
        return res;
      }
    }, [categories, arr, filters]);
    const list = arrs();
    const target = categories.catalogArr.find((cate) => cate.code == filters.category);
    if (target.level2.length !== list.length) {
      return null;
    }
    return (
      <>
        {list.map(({ featuredCate, partialState }, idx) => {
          if (partialState?.length) {
            return (
              <div key={idx}>
                <HeaderNav config={featuredCate} category={filters.category} getMore={getMore} />
                <div className={`grid ${colsClassNames[cols] || colsClassNames['5']} gap-4 mt-3 pb-4`}>
                  {partialState.map((m, index) => {
                    const using = !!currentLoraIdsMap[m.versionId] || currentCheckpointId === m.versionId;
                    return (
                      <ModelCard
                        data={m}
                        using={using}
                        key={m.versionId}
                        width={cardSize.width}
                        height={cardSize.height}
                        showTag={showTag}
                        query={filters.query}
                        showAuthorInfo={withAuthorInfo}
                        hotBadge={index < 3 && withHotBadge ? index + 1 : null}
                        onClick={applyModel}
                        onUpdate={updateModelItem}
                      />
                    );
                  })}
                </div>
              </div>
            );
          } else {
            return null;
          }
        })}
      </>
    );
    // }
  },
);
